import React, { useEffect, useState } from 'react'
import Item from './Item'
import axios from 'axios'

import {
  ContainerModal,
  ContentModal,
  List,
  ButtonContainer,
  ButtonConfirm,
  ButtonBack
} from './style'
import Loader from 'components/Loader'

const ModalResend = ({
  list,
  closeModal,
  token,
  setResendList,
  setMainCheck,
  checkAll,
  setLinks
}) => {
  const [newList, setNewList] = useState([])
  const [loading, setLoading] = useState(false)

  const handleResend = async () => {
    for (let i = 0; i < newList.length; i++) {
      const item = newList[i]

      setLoading(true)

      if (item !== undefined) {
        const body = {
          token: token || '',
          name: item.name || '',
          apelido: item.apelido || '',
          date: item.date || '',
          documentType: item.documentType || '',
          email: item.email || '',
          documentNumber: item.documentNumber || '',
          ciudad: item.ciudad || '',
          codigo_mun_tu: item.codigo_mun_tu || '',
          codigo_gera: item.codigo_gera || '',
          codigo_dept_tu: item.codigo_dept_tu || '',
          celular: item.celular || '',
          direccion: item.direccion || '',
          complemento: item.complemento || '',
          localNumber: item.localNumber || '',
          localType: item.localType || '',
          dateRegister: item.dateRegister || '',
          idReferencia: item.idReferencia || '',
          ipUser: item.ipUser || ''
        }

        try {
          await fetch('/.netlify/functions/createEquifax', {
            method: 'POST',
            body: JSON.stringify(body)
          })
            .then((res) => res.text())
            .then(async (data) => {
              const resulting = JSON.parse(data)

              const resultingStatus = resulting.clientImplementationStatus === 'completed'

              const updatedUser = {
                ...item,
                UUID: resultingStatus ? resulting.clientImplementationUUID : null,
                statusEquifax: resultingStatus ? true : false,
                log: JSON.stringify(resulting)
              }

              const { _id } = updatedUser
              delete updatedUser._id

              await axios.put('/.netlify/functions/updateLink', {
                id: _id,
                data: updatedUser
              })

              const newItem = { _id, ...updatedUser }

              await updateList(newItem, i)

              setLoading(false)
            })
        } catch (err) {
          setLoading(false)
          console.error('fetch failed', err)
        }
      }
    }

    setLoading(false)
  }

  const updateList = async (item, index) => {
    setNewList((oldlist) => {
      const updateList = [...oldlist]
      updateList[index] = item
      return updateList
    })

    setLinks((oldLinks) => {
      const updateLinks = { ...oldLinks }
      const indexLink = updateLinks.data.findIndex((el) => el._id === item._id)
      updateLinks.data[indexLink] = item

      return updateLinks
    })
  }

  useEffect(() => {
    setNewList(list)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ContainerModal>
      <ContentModal>
        <p>Relação de reenvio para Equifax</p>
        <List>
          <table>
            <thead>
              <tr>
                <td>Identificacion</td>
                <td>Nombres</td>
                <td>Email</td>
                <td>Fecha de registro</td>
                <td>Status</td>
                <td>Equifax</td>
              </tr>
            </thead>
            <tbody>
              {newList.length > 0 &&
                newList.map((link, index) => (
                  <Item key={link._id} link={link} modal={true} index={index} />
                ))}
            </tbody>
          </table>
        </List>
        <ButtonContainer>
          {!loading && (
            <ButtonBack
              onClick={(_) => {
                closeModal(false)
                setResendList([])
                setMainCheck(false)
                checkAll(false, 'modal')
              }}
            >
              Voltar
            </ButtonBack>
          )}
          {loading && <Loader />}
          {!loading && <ButtonConfirm onClick={(_) => handleResend()}>Reenviar</ButtonConfirm>}
        </ButtonContainer>
      </ContentModal>
    </ContainerModal>
  )
}

export default ModalResend
